<app-breadcrumb [master]="'Administracja'" [parentName]="'Chronie'" [name]="'Direct'"></app-breadcrumb>
<div class="hiperio-config-direct-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="hiperio-config-direct-list-filters">
  </form>

  <div class="hiperio-config-direct-list-buttons">

  </div>
  <table mat-table [dataSource]="list">
    <ng-container matColumnDef="tu">
      <th mat-header-cell *matHeaderCellDef > Nazwa TU</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/chronie/direct/szczegoly', element.id]">{{element.insuranceCompany.name}}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef > Nazwa identyfikatora</th>
      <td mat-cell *matCellDef="let element">
          <p *ngFor="let item of element.registrationIdName">
            {{ item }}
          </p>
      </td>
    </ng-container>
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef > Identyfikator</th>
      <td mat-cell *matCellDef="let element">
          <p *ngFor="let item of element.registrationId">
            {{ item }}
          </p>
      </td>
    </ng-container>
    <ng-container matColumnDef="ofwca">
      <th mat-header-cell *matHeaderCellDef > Imię i nazwisko OFWCA</th>
      <td mat-cell *matCellDef="let element">
        {{ element.registration?.ofwca?.fullName }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>

</div>
